import script from "./PrivateProductForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivateProductForm.vue?vue&type=script&setup=true&lang=js"

import "./PrivateProductForm.vue?vue&type=style&index=0&id=75160747&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75160747"]])

export default __exports__